const getSizeClass = (size) => {
	const normalizedSize = size.toLowerCase();

	if (normalizedSize === "large") {
		return "sizeLarge";
	}

	if (normalizedSize === "extralarge") {
		return "sizeExtraLarge";
	}

	if (normalizedSize === "full") {
		return "sizeFull";
	}

	if (normalizedSize === "auto") {
		return "sizeAuto";
	}

	return "sizeSmall";
};

export default getSizeClass;
